import axios from "axios";
import { utmBaseUrl } from "../helpers/constants";

export const getallmission = ({ queryKey }) => {
  return axios.get(`${utmBaseUrl}/v1/api/mission/`, {
    headers: { "x-access-token": queryKey[1] },
  });
};

export const addMission = ({ token, payload }) => {
  return axios.post(`${utmBaseUrl}/v1/api/mission/`, payload, {
    headers: { "x-access-token": token },
  });
};

export const getMissionDetails = (token, misisonId) => {
  return axios.get(`${utmBaseUrl}/v1/api/mission/${misisonId}`, {
    headers: { "x-access-token": token },
  })
}

export const missionPlanningByJamwant = (payload) => {
  return axios.post(`http://43.204.242.89:3008/api/admin/path-plan`, payload)
}

export const deleteMission = ({ missionId, token }) => {
  return axios.delete(`${utmBaseUrl}/v1/api/mission/${missionId}`, {
    headers: { "x-access-token": token },
  })
}